/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPPRODUCTCODE = {
    DiscretionarySavings: 'GAFDSP',
    Endowment: 'GAFEND',
    RetirementIncomeSolutionLivingAnnuity: 'GAFLAI',
    ManagedLivingAnnuity: 'GAFLAM',
    LivingAnnuity: 'GAFLAN',
    PreservationPensionFund: 'GAFPPE',
    PreservationProvidentFund: 'GAFPPR',
    RetirementAnnuityFund: 'GAFRAF',
    SinkingFund: 'GAFSNK',
    TaxFreeSavings: 'GAFTFS'
} as const;
export type IAPPRODUCTCODE = typeof IAPPRODUCTCODE[keyof typeof IAPPRODUCTCODE];


export function IAPPRODUCTCODEFromJSON(json: any): IAPPRODUCTCODE {
    return IAPPRODUCTCODEFromJSONTyped(json, false);
}

export function IAPPRODUCTCODEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPPRODUCTCODE {
    return json as IAPPRODUCTCODE;
}

export function IAPPRODUCTCODEToJSON(value?: IAPPRODUCTCODE | null): any {
    return value as any;
}

